import { BsFiletypeXlsx } from 'react-icons/bs';
import { Button } from '../../../../../components/button/button';
import { Dropdown } from '../../../../../components/dropdown/dropdown';
import { Loader } from '../../../../../components/loader/loader';
import { Page } from '../../../../../components/page/page';
import { Select } from '../../../../../components/select/select';
import { DropZone } from '../../../../../features/drop-zone/drop-zone';
import { gridTemplates } from '../../../../../helpers/mappers';
import { shiftsTemplateDownload } from '../../../../../store/api/shifts-api';
import { ShiftsDates } from '../shifts/shifts-dates/shifts-dates';
import { ShiftsGrid } from '../shifts/shifts-grid/shifts-grid';
import s from './shifts-import.module.css';
import { useShiftsImport } from './use-shifts-import';

export const ShiftsImport = () => {
  const {
    branch,
    branches,
    file,
    handleConfirm,
    handleDrop,
    isDisabledUpload,
    isLoading,
    setBranch,
    t,
    isDropDisabled,
  } = useShiftsImport();

  return (
    <Page className={s.page}>
      <h2>{t('Импорт из файла')}</h2>
      {isLoading && <Loader />}
      <div className={s.drop}>
        <DropZone
          onDrop={handleDrop}
          acceptedFiles={{ 'text/csv': ['.csv'], 'spreadsheet/xlsx': ['.xlsx'] }}
          helpText={t('Формат: XSLX, CSV')}
          disabled={isDropDisabled}
          disabledText={t('Сначала выберите филиал')}
        />

        <div className={s.controls}>
          <Dropdown
            leftIcon={<BsFiletypeXlsx />}
            className={s.dropdown}
            optionsClassName={s.options}
            label={t('Скачать шаблон')}
            options={gridTemplates.map((item) => ({
              key: item,
              label: item,
              onClick: () => shiftsTemplateDownload(item),
            }))}
          />
          <Select
            options={branches}
            value={branch}
            onSelect={setBranch}
            withSearch
            placeholder={t('Филиал')}
          />
          <Button variant="primary" size="lg" disabled={isDisabledUpload} onClick={handleConfirm}>
            {t('Загрузить файл') + `${file ? ` ${file.name}` : ''}`}
          </Button>
        </div>
      </div>
      <div className={s.preview}>
        <ShiftsDates />
        <ShiftsGrid />
      </div>
    </Page>
  );
};
